import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  root: FelaCSS;
  button: FelaCSS;
}

const styles: IStyles = {
  root: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  button: {
    border: '2px solid rgba(26, 44, 64, 0.1)',
    borderRadius: '100px',
    ':hover': {
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.1)',
    },
  },
};

export default styles;
